/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_NoInputs */

const en_embed_captions_no = /** @type {(inputs: Embed_Captions_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No`)
};

const fr_embed_captions_no = /** @type {(inputs: Embed_Captions_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non`)
};

const de_embed_captions_no = /** @type {(inputs: Embed_Captions_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`NEIN`)
};

const it_embed_captions_no = /** @type {(inputs: Embed_Captions_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`NO`)
};

const ru_embed_captions_no = /** @type {(inputs: Embed_Captions_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нет`)
};

const es_embed_captions_no = /** @type {(inputs: Embed_Captions_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No`)
};

const zh_cn2_embed_captions_no = /** @type {(inputs: Embed_Captions_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不`)
};

const ja_embed_captions_no = /** @type {(inputs: Embed_Captions_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いいえ`)
};

const hi_embed_captions_no = /** @type {(inputs: Embed_Captions_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नहीं`)
};

const pt_pt2_embed_captions_no = /** @type {(inputs: Embed_Captions_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não`)
};

/**
* | output |
* | --- |
* | "No" |
*
* @param {Embed_Captions_NoInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_no = /** @type {((inputs?: Embed_Captions_NoInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_NoInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_embed_captions_no(inputs)
	if (locale === "de") return de_embed_captions_no(inputs)
	if (locale === "it") return it_embed_captions_no(inputs)
	if (locale === "ru") return ru_embed_captions_no(inputs)
	if (locale === "es") return es_embed_captions_no(inputs)
	if (locale === "zh-CN") return zh_cn2_embed_captions_no(inputs)
	if (locale === "ja") return ja_embed_captions_no(inputs)
	if (locale === "hi") return hi_embed_captions_no(inputs)
	if (locale === "pt-PT") return pt_pt2_embed_captions_no(inputs)
	return en_embed_captions_no(inputs)
});